import { Attrs, MinzeElement, Reactive } from 'minze'
import Swiper from 'swiper'
import styles from 'swiper/swiper-bundle.min.css?inline'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'blogSlider', {
  title: 'Blogue',
  viewMore: 'Voir tous les articles',
  viewMoreLink: '/fr/blogue',
})
Locale.getInstance().registerKeySet('en', 'blogSlider', {
  title: 'Blog',
  viewMore: 'View all articles',
  viewMoreLink: '/en/blog',
})
export interface LvcBlogSlider {
  data: BlogCardData[] | null
  dataBlogItems: string
  parsedBlogItems: BlogCardData[]
}
export interface BlogCardData {
  id: string
  data: {
    title: {
      fr: string
      en: string
    }
    slug: {
      fr: string
      en: string
    }
    description: {
      fr: string | null
      en: string | null
    }
    image?: string | null
    imageAltText?: string | null
    publishAt: string // ISO date format
    publishAtLabel: {
      fr: string
      en: string
    }
    partner?: string
    readingTime: number
    readingTimeLabel: {
      fr: string
      en: string
    }
    authorName: {
      fr: string
      en: string
    }
    authorImage?: string | null
    type: {
      id: string
      data: {
        label: {
          fr: string
        }
      }
    }
    category: {
      id: string
      data: {
        label: {
          fr: string
        }
        slug: {
          fr: string
          en: string
        }
      }
    }
    typeLabel: string
    categoryLabel: {
      fr: string
      en: string
    }
    urlConstruct: {
      fr: string
      en: string
    }
  }
}
export class LvcBlogSlider extends MinzeElement {
  attrs: Attrs = ['data-blog-items']
  // reactive: Reactive = [
  //   ['data', null]
  // ]
  onRender = () => {
    const swiperContainer = this.select('.blog-swiper-container') as HTMLElement
    if (!swiperContainer) return
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1.1,
      spaceBetween: 30,
      updateOnWindowResize: true,
      breakpoints: {
        768: {
          slidesPerView: 2.1,
        },
        992: {
          slidesPerView: 3.75,
        },
      },
    })
  }
  html = () => `
  
    
    <div class="blog-slider-title-wrapper">
      <div class="blog-slider-title-text-wrapper">      
        <h2 class="blog-slider-title">${Locale.getKey('blogSlider.title')}</h2>
        <div class="blog-slider-counter">${JSON.parse(decodeURIComponent(this.dataBlogItems)).length}</div>
      </div>
      <div class="view-more-wrapper">
        <a class="view-more-link" href="${Locale.getKey('blogSlider.viewMoreLink')}" class="blog-slider-link">
          <div class="view-more-text">${Locale.getKey('blogSlider.viewMore')}</div>
          <div class="view-more-icon-wrapper">
            <lvc-arrow-right-icon width="25px" height="25px"></lvc-arrow-right-icon>
          </div>
        </a>
      </div>
    </div>
      <div class="blog-swiper-container">
        <div class="swiper-wrapper">
          ${JSON.parse(decodeURIComponent(this.dataBlogItems))
            .map(
              (item: BlogCardData) => `
            <div class="swiper-slide">
              <lvc-blog-card data="${encodeURIComponent(JSON.stringify(item))}"></lvc-blog-card>
            </div>
          `
            )
            .join('')}
        </div>
      </div>
    <div class="view-more-wrapper-mobile">
      <div class="view-more-wrapper is-mobile">
        <a class="view-more-link" href="${Locale.getKey('blogSlider.viewMoreLink')}" class="blog-slider-link">
          <div class="view-more-text">${Locale.getKey('blogSlider.viewMore')}</div>
          <div class="view-more-icon-wrapper">
            <lvc-arrow-right-icon width="25px" height="25px"></lvc-arrow-right-icon>
          </div>
        </a>
      </div>
    </div>
  `
  css = () => `
  ${styles}
  :host {
    color: #1E007D;
  }
  .blog-slider-title-text-wrapper {
    display: flex;
    align-items: center;

  }
  .view-more-wrapper-mobile {
    display: none;
  }
  .blog-slider-counter {
    display: inline-block;
    font-size: 18px;
    margin-left: 8px;
    margin-top: -11px;
    font-weight: 500;
    color: #1E007D;
  }
  .view-more-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
  }
  lvc-arrow-right-icon {
        width: 25px;
        height: 25px;
        transform: rotate(-35deg);
      }
  .view-more-wrapper {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #1E007D;
    padding-bottom: 2px;
    padding-top: 2px;
  }
  .view-more-wrapper.is-mobile {
    display: none;
  }
  .view-more-link {
    font-size: 18px;
    font-weight: 500;
    color: #1E007D;
    text-transform: uppercase;
    display: flex;
    text-decoration: none;
    align-items: center;
    gap: 10px;
  }
  .blog-slider-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3rem;
  }
  .blog-slider-title {
    font-size: 40px;
    font-weight: 800;
    margin: 0;
  }
  .loader-layout {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    gap: 20px;
  }
  .loader-layout > div {
    background-color: #f0f0f0;
    border-radius: 10px;
    height: 410px;
    width: 100%;
    animation: loading 3s infinite;
  }
  @media screen and (max-width: 991px) {
    .view-more-wrapper-mobile{
      display: flex;

    }
    .loader-layout {
      grid-template-columns: 1fr;
    }
    .loader-layout > div {
      display: none;
    }
    .loader-layout > div:nth-child(1) {
      display: block;
    }
    .blog-slider-title-wrapper {
      flex-wrap: wrap;
      gap: 0;
      margin-bottom: 2rem;
    }
    .blog-slider-title {
      font-size: 2rem;
      margin: 0;
    }
    .blog-slider-counter {
      display: inline-block;
      font-size: 16px;
      margin-left: 7px;
      margin-top: -9px;
      font-weight: 400;
      color: #1E007D;
    }
    .view-more-wrapper {
      display: none;
      gap: 4px;
    }
    .view-more-wrapper.is-mobile {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      justify-content: center;
      margin-top: 2rem;
      padding-top: 1px;
      padding-bottom: 1px;
    }
    .view-more-link {
      font-size: 14px;
      gap: 6px;
    }
  }



  @keyframes loading {
    0% {
      background-color: rgba(0, 0, 0, 0.1);
    }
    50% {
      background-color: rgba(0, 0, 0, 0.2);
    }
    100% {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
`

  // async onReactive() {
  //   if (testMode) {
  //     this.data = testData as BlogCardData[]
  //     return
  //   }
  //   const resp = await fetch(`${config.backendApi}/content/getHomepage`)
  //   const data = await resp.json()
  //   this.data = data.blogShowcase as BlogCardData[]
  //   this.loading = false
  // }
}
